import { render } from "./ViewCreateModal.vue?vue&type=template&id=1d28a943&scoped=true&ts=true"
import script from "./ViewCreateModal.vue?vue&type=script&lang=ts"
export * from "./ViewCreateModal.vue?vue&type=script&lang=ts"

import "./ViewCreateModal.vue?vue&type=style&index=0&id=1d28a943&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d28a943"]])

export default __exports__